import type { MarketplaceEntry } from "../types/index";
import { isOfficial } from "../lib/official";
import CheckIcon from "../icons/CheckIcon";
import styles from "./OfficialBadge.module.css";

const TITLE = "Official CAI — curated by Cox Automotive for broad enterprise use";

interface OfficialCheckProps {
  plugin: MarketplaceEntry;
  /** Diameter of the check circle in px. */
  size?: number;
  /** When true, the circle is purely decorative (a sibling label already names it). */
  decorative?: boolean;
}

/**
 * Compact Official indicator — a green check circle for dense catalog views
 * (cards, list rows). Renders nothing for non-Official entries.
 */
export function OfficialCheck({ plugin, size = 18, decorative = false }: OfficialCheckProps) {
  if (!isOfficial(plugin)) return null;
  const a11y = decorative
    ? { "aria-hidden": true as const }
    : { role: "img", "aria-label": "Official CAI", title: TITLE };
  return (
    <span className={styles.check} style={{ width: size, height: size }} {...a11y}>
      <CheckIcon />
    </span>
  );
}

/**
 * Labeled "Official CAI" pill for the detail title. Renders nothing for
 * non-Official entries.
 */
export function OfficialBadge({ plugin }: { plugin: MarketplaceEntry }) {
  if (!isOfficial(plugin)) return null;
  return (
    <span className={styles.badge} title={TITLE}>
      <OfficialCheck plugin={plugin} size={14} decorative />
      Official CAI
    </span>
  );
}
